import theme from '../../../../lib/theme';
import { LightDestinationProps } from './LightDestination';

const {
  corners,
  colors,
  media,
  font: {
    heights,
    spacings,
    families,

    ...font
  },
} = theme;

export default ({ size = 'm' }: LightDestinationProps) => {
  const avatarSizes = {
    s: 40,
    m: 60,
    l: 90,
    xl: 90,
  };

  const nameSizes: any = {
    s: 'm',
    m: 'l',
    l: 'xl',
    xl: 'xxxl',
  };

  const titleSizes: any = {
    s: 's',
    m: 's',
    xl: 'm',
  };

  const taglineSizes: any = {
    s: 'm',
    m: 'm',
    xl: 'l',
  };

  return {
    link: {
      textDecoration: 'none',

      '&:hover .StoryAuthor__name': {
        color: colors.sas.primary,
        textDecoration: 'underline',
      },
    },

    author: {
      fontFamily: families.primary,
      fontSize: font.s,
      fontWeight: font.normal,
      letterSpacing: spacings.m,
      lineHeight: 1,
      textDecoration: 'none !important',
    },

    avatar: {
      width: `${size === 's' ? avatarSizes.s : avatarSizes.m}px !important`,
      height: `${size === 's' ? avatarSizes.s : avatarSizes.m}px !important`,
      borderRadius: corners.m,
      border: `1px solid ${colors.grey}`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      backgroundPosition: 'center',

      [media.s.up]: {
        width: `${avatarSizes[size]}px !important`,
        height: `${avatarSizes[size]}px !important`,
      },
    },

    authorTitle: {
      textTransform: 'uppercase',
      letterSpacing: spacings.m,
      color: colors.black,
      whiteSpace: 'nowrap',
      fontSize: font[size === 's' ? titleSizes.s : titleSizes.m],

      [media.s.up]: {
        fontSize: font[titleSizes[size]],
      },
    },

    authorName: {
      fontFamily: families.primary,
      fontWeight: font.bold,
      color: colors.black,
      transition: 'all 150ms linear',
      whiteSpace: 'nowrap',
      fontSize: size === 's' ? nameSizes.s : nameSizes.m,

      [media.s.up]: {
        fontSize: font[nameSizes[size]],
      },
    },

    authorTagline: {
      fontFamily: families.primary,
      color: colors.black,
      whiteSpace: 'nowrap',
      fontSize: font[size === 's' ? taglineSizes.s : taglineSizes.m],

      [media.s.up]: {
        fontSize: font[taglineSizes[size]],
      },
    },
  };
};
